module.exports = __webpack_public_path__ + "img/company.05c9c6f5.png";